import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function AfterSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4 md:px-6 bg-coral/5" data-id="element-18">
      <div className="max-w-3xl mx-auto text-center" data-id="element-19">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} className="font-serif text-3xl md:text-4xl font-bold text-charcoal mb-8" data-id="element-20">
          What happens after they open it
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        delay: 0.2
      }} className="space-y-6 text-lg text-warm-gray mb-12" data-id="element-21">
          <p data-id="element-22">Here’s the best part. This isn’t a one-and-done gift.</p>
          <p data-id="element-23">It becomes a shared language:</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {
        opacity: 0,
        scale: 0.9
      }} transition={{
        delay: 0.4,
        type: 'spring',
        bounce: 0.4
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border-2 border-dashed border-coral/30 relative inline-block mx-auto transform rotate-1" data-id="element-24">
          <div className="absolute -top-3 -left-3 w-6 h-6 bg-coral rounded-full" data-id="element-25"></div>
          <div className="absolute -bottom-3 -right-3 w-6 h-6 bg-teal rounded-full" data-id="element-26"></div>

          <p className="font-serif text-3xl md:text-5xl font-bold text-charcoal leading-tight" data-id="element-27">
            “Grandma, <br data-id="element-28" />
            <span className="text-coral" data-id="element-29">can I redeem one?</span>”
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        delay: 0.6
      }} className="mt-12 text-lg text-warm-gray" data-id="element-30">
          And suddenly, your relationship has built-in closeness—without you
          having to constantly “think of something.”
        </motion.p>
      </div>
    </section>;
}